/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_ButtonInputs */

const en_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout`)
};

const id_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran`)
};

const ms_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayar`)
};

const ca_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tramitar compra`)
};

const cs_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokladna`)
};

const da_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasse`)
};

const de_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Kasse`)
};

const et_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kassa`)
};

const es_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago`)
};

const fr_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement`)
};

const hr_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plaćanje`)
};

const it_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout`)
};

const lv_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norēķināties`)
};

const lt_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atsiskaityti`)
};

const hu_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pénztár`)
};

const nl_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrekenen`)
};

const nb_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til betaling`)
};

const pl_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasa`)
};

const pt_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizar`)
};

const ro_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizarea plății`)
};

const sk_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokladňa`)
};

const sl_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blagajna`)
};

const fi_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kassa`)
};

const sv_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kassa`)
};

const vi_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán`)
};

const tr_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödeme`)
};

const el_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ταμείο`)
};

const bg_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Финализиране`)
};

const ru_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оплатить заказ`)
};

const sr_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плаћање`)
};

const uk_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оформити`)
};

const ka_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გადახდა`)
};

const hi_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चेकआउट`)
};

const th_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชำระเงิน`)
};

const ko_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`체크아웃`)
};

const zh_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结账`)
};

const zh_tw_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結帳`)
};

const ja_checkout_button = /** @type {(inputs: Checkout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チェックアウト`)
};

/**
* | output |
* | --- |
* | "Checkout" |
*
* @param {Checkout_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const checkout_button = /** @type {((inputs?: Checkout_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_checkout_button(inputs)
	if (locale === "ms") return ms_checkout_button(inputs)
	if (locale === "ca") return ca_checkout_button(inputs)
	if (locale === "cs") return cs_checkout_button(inputs)
	if (locale === "da") return da_checkout_button(inputs)
	if (locale === "de") return de_checkout_button(inputs)
	if (locale === "et") return et_checkout_button(inputs)
	if (locale === "es") return es_checkout_button(inputs)
	if (locale === "fr") return fr_checkout_button(inputs)
	if (locale === "hr") return hr_checkout_button(inputs)
	if (locale === "it") return it_checkout_button(inputs)
	if (locale === "lv") return lv_checkout_button(inputs)
	if (locale === "lt") return lt_checkout_button(inputs)
	if (locale === "hu") return hu_checkout_button(inputs)
	if (locale === "nl") return nl_checkout_button(inputs)
	if (locale === "nb") return nb_checkout_button(inputs)
	if (locale === "pl") return pl_checkout_button(inputs)
	if (locale === "pt") return pt_checkout_button(inputs)
	if (locale === "ro") return ro_checkout_button(inputs)
	if (locale === "sk") return sk_checkout_button(inputs)
	if (locale === "sl") return sl_checkout_button(inputs)
	if (locale === "fi") return fi_checkout_button(inputs)
	if (locale === "sv") return sv_checkout_button(inputs)
	if (locale === "vi") return vi_checkout_button(inputs)
	if (locale === "tr") return tr_checkout_button(inputs)
	if (locale === "el") return el_checkout_button(inputs)
	if (locale === "bg") return bg_checkout_button(inputs)
	if (locale === "ru") return ru_checkout_button(inputs)
	if (locale === "sr") return sr_checkout_button(inputs)
	if (locale === "uk") return uk_checkout_button(inputs)
	if (locale === "ka") return ka_checkout_button(inputs)
	if (locale === "hi") return hi_checkout_button(inputs)
	if (locale === "th") return th_checkout_button(inputs)
	if (locale === "ko") return ko_checkout_button(inputs)
	if (locale === "zh") return zh_checkout_button(inputs)
	if (locale === "zh-tw") return zh_tw_checkout_button(inputs)
	if (locale === "ja") return ja_checkout_button(inputs)
	return en_checkout_button(inputs)
});